import type { ReactNode } from 'react';
import { ArrowRight } from 'lucide-react';
import { AssetMarketplace } from '../../../components/marketplace';
import type { MarketplaceAsset } from '../../../types/marketplace';

export interface KnowledgePanelProps {
  assets: MarketplaceAsset[];
  /** 知识条目数量（展示在橱窗标题）。 */
  count: number;
  /** 跳转知识库管理页。 */
  onManage: () => void;
  /** 知识在线服务工具栏节点。 */
  toolbar: ReactNode;
}

/** 知识维度面板：知识库橱窗（只读展示 + 跳转知识库管理）。 */
export default function KnowledgePanel({ assets, count, onManage, toolbar }: KnowledgePanelProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 style={{ margin: 0 }}>知识库橱窗 ({count})</h3>
        <button
          className="primary"
          style={{ padding: '6px 12px', fontSize: 13 }}
          onClick={onManage}
        >
          管理知识库 <ArrowRight size={12} />
        </button>
      </div>
      {toolbar}
      <AssetMarketplace
        assets={assets}
        initialType="knowledge"
        hideTypeFilter
        title=""
      />
    </div>
  );
}
